import * as React from 'react';
import ITranslationsContext from './translations-context.interface';

const defaultContext: ITranslationsContext = {
  translations: {}
};

const TranslationsContext = React.createContext<ITranslationsContext>(defaultContext);
export default TranslationsContext;